import { ScoresType } from "../StatType";

export default class ScoresModel {
  public ftScore: ScoresType = null;
  public htScore: ScoresType = null;
  public aetScore: ScoresType = null;
  public aggScore: ScoresType = null;
  public penScore: ScoresType = null;
}